module.exports = __webpack_public_path__ + "img/Wp_2091.e5c4720b.png";